import React from 'react';

const CheckOut = () => {
    return (
        <div>
            <p>Now You Can CheckOut.</p>
        </div>
    );
};

export default CheckOut;